import { useLanguage } from '@/context/LanguageContext';
import { Button } from '@/components/ui/button';
import { Globe } from 'lucide-react';

const LanguageToggle = ({ className = '' }) => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className={`text-zinc-400 hover:text-white gap-2 ${className}`}
      data-testid="language-toggle"
    >
      <Globe size={16} />
      <span className="text-xs uppercase tracking-wider">{language === 'es' ? 'EN' : 'ES'}</span>
    </Button>
  );
};

export default LanguageToggle;
